import { normalize } from 'normalizr';
import { channel } from 'shared/schemas';

import createAsyncActions from 'shared/redux/helpers/create-async-actions';


const ACTIONS = createAsyncActions('CLIENT.CHANNEL.UPDATE', ['SUCCESS']);
export const NAMES = ACTIONS.NAMES;
const { SUCCESS } = ACTIONS;

export { SUCCESS };


export default function (data) {
  data = normalize(data, channel);

  return function (dispatch) {
    dispatch(SUCCESS({}, { data }));
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/client/actions/channel/update.js